var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37 0 0 5.37 0 12C0 18.63 5.37 24 12 24C18.63 24 24 18.63 24 12C24 5.37 18.63 0 12 0ZM4.8 7.05H19.19C19.28 7.05 19.33 7.17 19.25 7.23L12.53 12.67C12.22 12.92 11.77 12.92 11.46 12.67L4.74 7.23C4.67 7.17 4.71 7.05 4.8 7.05ZM19.48 15.95C19.48 16.5 19.03 16.95 18.48 16.95H5.52C4.97 16.95 4.52 16.5 4.52 15.95V8.36C4.52 8.28 4.62 8.23 4.68 8.28L11.31 13.69C11.7 14.05 12.29 14.05 12.68 13.69L19.31 8.28C19.38 8.23 19.47 8.28 19.47 8.36V15.95H19.48Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.a15595df536d6934c4d58052159535ee.svg";
export { ForwardRef as ReactComponent };